<template>
  <div>
    <TermosDeUsoComponent
      :buttons-footer="true"
      :id-termo="step.idTermosUso"
      :titulo="titulo"
      :esconder-header="true"
      @aceito="proximo"
      @dataAceite="bypass"
      @cancelar="voltar"
      @voltar="voltar"
    />
  </div>
</template>
<script>
import TermosDeUsoComponent from '@/components/TermosDeUso/TermosDeUsoComponent'

export default {
  name: 'TemplateStepTermoDeUso',
  components: { TermosDeUsoComponent },
  props: {
    step: {
      type: Object
    },
    titulo: {
      type: String
    }
  },
  methods: {
    proximo (payload) {
      this.$emit('proximo', { aceite: payload })
    },
    bypass (payload) {
      if (payload) {
        this.$emit('bypass', {
          aceite: payload,
          bypass: true
        })
      }
    },
    voltar () {
      this.$emit('cancelar')
    }
  }
}
</script>
<style scoped>
</style>
